import React, {useState, useEffect} from 'react';
import {useContext, useContextSelector} from 'use-context-selector';
import {Dropdown} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faGlobe} from '@fortawesome/free-solid-svg-icons/faGlobe'

import {LocalContext} from '../context/LocalContext';
import {SessionContext} from '../context/SessionContext';

import languageNames from '../util/languageNames';

const LanguageSwitch = (props) => {
    const {t} = useTranslation();

    const [sessionData, setSessionData] = useContext(SessionContext);
    const [localData, setLocalData] = useContext(LocalContext);

    const clientOnline = useContextSelector(LocalContext, v => v[0].clientOnline);
    const cookiesPolicyAccepted = useContextSelector(LocalContext, v => v[0].cookiesPolicy.accepted);
    const userAuthenticated = useContextSelector(LocalContext, v => v[0].user.authenticated);

    const UILangGuest = useContextSelector(LocalContext, v => v[0].UILang);
    const UILangSession = useContextSelector(SessionContext, v => v[0].UILang);

    const [languagesList, setLanguagesList] = useState([]);

    useEffect(() => {
        const languagesEnabled = process.env.REACT_APP_CLIENT_LANGUAGES.split(',');
        if (languagesEnabled.length > 0 && languagesList.length === 0) {
            const newLanguagesList = languagesEnabled.map((enabledCode) => {
                if (languageNames[enabledCode]) {
                    return {
                        language: enabledCode,
                        title: languageNames[enabledCode].nativeName.split(',')[0].replace(/^./, languageNames[enabledCode].nativeName[0].toUpperCase()),
                        current: false,
                        available: process.env.REACT_APP_CLIENT_LANGUAGES.split(',').indexOf(enabledCode) !== -1
                    };
                }
                return null
            });
            setLanguagesList(newLanguagesList);
        }
    }, [languagesList, setLanguagesList]);

    useEffect(() => {
        const newLanguagesList = [];
        let languageChanged = false;

        let currentLang;
        if (cookiesPolicyAccepted) {
            currentLang = UILangGuest;
        } else {
            currentLang = UILangSession;
        }

        for (const language of languagesList) {
            if (language.language === currentLang && !language.current) {
                languageChanged = true;
                newLanguagesList.push({...language, current: true});
            } else if (language.language !== currentLang && language.current) {
                languageChanged = true;
                newLanguagesList.push({...language, current: false});
            } else {
                newLanguagesList.push({...language});
            }
        }

        if (languageChanged) {
            setLanguagesList([...newLanguagesList]);
        }
    }, [languagesList, setLanguagesList, cookiesPolicyAccepted, userAuthenticated, UILangSession, UILangGuest]);

    const setNewUILang = (language) => {
        if (cookiesPolicyAccepted) {
            setLocalData({...localData, UILang: language});
        } else {
            setSessionData({...sessionData, UILang: language})
        }
    }

    return (<Dropdown alignRight>
        <Dropdown.Toggle disabled={!clientOnline} variant={props.variant ? props.variant : "outline-light"} title="Change Language">
            <span>
                <FontAwesomeIcon size="sm" icon={faGlobe} />
            </span>
            {
                !props.noLabel ?
                    <span className="ml-2">
                        {t(`LanguageSwitch.language`)}
                    </span> :
                    null
            }
        </Dropdown.Toggle>

        <Dropdown.Menu
            style={
                {
                    maxHeight: `calc(100vh - 44px - 1rem)`,
                    overflow: `auto`,
                }
            }
        >
            {
                languagesList.length > 0 ?
                    languagesList.map(
                        (item, index) => {
                            if (item.available) {
                                return <Dropdown.Item
                                    disabled={item.current}
                                    key={index}
                                    onClick={() => {setNewUILang(item.language)}}
                                >
                                    {item.title}
                                </Dropdown.Item>
                            }
                            return null
                        }
                    ) : null
            }
        </Dropdown.Menu>
    </Dropdown>);
}

export default LanguageSwitch;
